<div class="header">
  <div class="object-name">
    {{ attributes.id }}
  </div>
  <div class="sub-header">
    {{ attributes.type }}
  </div>
</div>
<div class="info-container">
  @if (attributes.function) {
    <div class="info">
      <p class="field-title">Function</p>
      {{ attributes.function }}
    </div>
  }
  @if (attributes.coordinates) {
    <div class="info">
      <p class="field-title">Coordinates</p>
      {{ attributes.coordinates }}
    </div>
  }
  @if (attributes.magneticVariation) {
    <div class="info">
      <p class="field-title">Magnetic Variation</p>
      {{ attributes.magneticVariation }}
    </div>
  }
  @if (attributes.minReceptionAlt) {
    <div class="info">
      <p class="field-title">Minimum Reception Altitude</p>
      {{ attributes.minReceptionAlt }}
    </div>
  }
  @if (attributes.minCrossingAlt) {
    <div class="info">
      <p class="field-title">Minimum Crossing Altitude</p>
      {{ attributes.minCrossingAlt }}
    </div>
  }
  @if (attributes.usage) {
    <div class="info">
      <p class="field-title">Usage</p>
      {{ attributes.usage }}
    </div>
  }
</div>
